/* Tech Store — storefront interactions: hero carousel, ajax add-to-cart, variant selector */
(function () {
  var routes = (window.TechStore && window.TechStore.routes) || {};
  var moneyFormat = (window.TechStore && window.TechStore.money_format) || '${{amount}}';

  /* ---------- money ---------- */
  function formatMoney(cents) {
    cents = cents || 0;
    function fmt(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      var value = (number / 100.0).toFixed(precision);
      var parts = value.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cent = parts[1] ? decimal + parts[1] : '';
      return dollars + cent;
    }
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, name) {
      switch (name) {
        case 'amount': return fmt(cents, 2);
        case 'amount_no_decimals': return fmt(cents, 0);
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_space_separator': return fmt(cents, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return fmt(cents, 0, ' ', '');
        default: return fmt(cents, 2);
      }
    });
  }

  window.TechStore = window.TechStore || {};
  window.TechStore.formatMoney = formatMoney;

  /* ---------- cart count ---------- */
  function refreshCartCount() {
    fetch(routes.cart_url ? routes.cart_url + '.js' : '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-ts-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      })
      .catch(function () {});
  }

  function flashButton(btn, text) {
    if (!btn) return;
    var label = btn.querySelector('[data-ts-add-label]') || btn;
    var original = label.textContent;
    label.textContent = text;
    setTimeout(function () { label.textContent = original; }, 1400);
  }

  /* ---------- ajax add to cart ---------- */
  function ajaxAdd(form) {
    var btn = form.querySelector('button[type="submit"]');
    var data = new FormData(form);
    fetch(routes.cart_add_url || '/cart/add', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: data
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) { flashButton(btn, 'Unavailable'); return; }
        flashButton(btn, 'Added ✓');
        refreshCartCount();
      })
      .catch(function () { flashButton(btn, 'Error'); });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-ts-add], [data-ts-product-form]');
    if (!form) return;
    e.preventDefault();
    ajaxAdd(form);
  });

  /* ---------- cart line quantity / remove (progressive enhancement) ---------- */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-ts-cart-line] a[href*="/cart/change"]');
    if (!link) return;
    e.preventDefault();
    var url = new URL(link.href, window.location.origin);
    var line = url.searchParams.get('line');
    var qty = url.searchParams.get('quantity');
    fetch((routes.cart_change_url || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(qty) })
    })
      .then(function () { window.location.reload(); })
      .catch(function () { window.location.href = link.href; });
  });

  /* ---------- hero carousel ---------- */
  function initHero(hero) {
    if (hero.dataset.tsHeroInit) return;
    hero.dataset.tsHeroInit = '1';
    var slides = Array.prototype.slice.call(hero.querySelectorAll('[data-ts-hero-slide]'));
    var texts = Array.prototype.slice.call(hero.querySelectorAll('[data-ts-hero-text]'));
    var dots = Array.prototype.slice.call(hero.querySelectorAll('[data-ts-hero-dot]'));
    if (slides.length <= 1) return;
    var idx = 0, timer;

    function go(i) {
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === idx); });
      texts.forEach(function (t, n) { t.classList.toggle('is-active', n === idx); });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === idx); });
    }
    function start() { timer = setInterval(function () { go(idx + 1); }, 5000); }
    function stop() { clearInterval(timer); }

    dots.forEach(function (d, n) {
      d.addEventListener('click', function () { stop(); go(n); start(); });
    });
    go(0); start();
    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);
  }

  /* ---------- product variant selector ---------- */
  function initProduct(root) {
    if (root.dataset.tsProductInit) return;
    root.dataset.tsProductInit = '1';
    var variants;
    var dataEl = root.querySelector('[data-ts-variants]');
    try { variants = JSON.parse(dataEl ? dataEl.textContent : '[]'); } catch (e) { variants = []; }
    if (!variants.length) return;

    var idInput = root.querySelector('[data-ts-variant-id]');
    var priceEl = root.querySelector('[data-ts-price]');
    var stockDot = root.querySelector('[data-ts-stock-dot]');
    var stockText = root.querySelector('[data-ts-stock-text]');
    var addBtn = root.querySelector('[data-ts-add-btn]');
    var addLabel = root.querySelector('[data-ts-add-label]');
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-ts-option]'));
    if (!buttons.length) return;

    var current = variants.filter(function (v) { return String(v.id) === String(idInput.value); })[0] || variants[0];
    var selected = (current.options || []).slice();

    function paint() {
      buttons.forEach(function (b) {
        var pos = parseInt(b.getAttribute('data-ts-option'), 10) - 1;
        var on = selected[pos] === b.getAttribute('data-ts-value');
        b.style.borderColor = on ? 'var(--logo,#6d28d9)' : 'var(--border,#e6e6ea)';
        b.style.background = on ? 'color-mix(in srgb,var(--logo,#6d28d9) 7%,transparent)' : 'var(--bg,#fff)';
      });
    }

    function match() {
      return variants.filter(function (v) {
        return (v.options || []).every(function (o, i) { return o === selected[i]; });
      })[0];
    }

    function update() {
      var v = match();
      paint();
      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.style.opacity = '.4'; addBtn.style.cursor = 'not-allowed'; }
        if (addLabel) addLabel.textContent = 'Unavailable';
        return;
      }
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (stockDot) stockDot.style.background = v.available ? '#1f8a5b' : '#b91c1c';
      if (stockText) stockText.textContent = v.available ? 'In stock' : 'Sold out';
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.style.opacity = v.available ? '1' : '.4';
        addBtn.style.cursor = v.available ? 'pointer' : 'not-allowed';
      }
      if (addLabel) addLabel.textContent = v.available ? 'Add to cart' : 'Sold out';
    }

    buttons.forEach(function (b) {
      b.addEventListener('click', function () {
        var pos = parseInt(b.getAttribute('data-ts-option'), 10) - 1;
        selected[pos] = b.getAttribute('data-ts-value');
        update();
      });
    });
    paint();
  }

  /* ---------- marquee ---------- */
  /* The CSS loop translates the track by -50%, which is only seamless when each
     half of the track is at least as wide as the viewport. Merchants control the
     item list, so repeat the items inside both halves until that holds. */
  function fillMarquee(track) {
    var copies = Array.prototype.slice.call(track.querySelectorAll('.ts-marquee-copy'));
    if (copies.length !== 2) return;
    var baseline = track.dataset.tsMarqueeBase;
    if (!baseline) { baseline = copies[0].innerHTML; track.dataset.tsMarqueeBase = baseline; }
    copies.forEach(function (c) { c.innerHTML = baseline; });
    var need = (track.parentElement || track).clientWidth;
    var unit = copies[0].scrollWidth;
    if (!unit || !need) return;
    var reps = Math.max(1, Math.ceil(need / unit));
    if (reps > 1) {
      var html = '';
      for (var i = 0; i < reps; i++) html += baseline;
      copies.forEach(function (c) { c.innerHTML = html; });
    }
    /* Keep perceived speed constant regardless of how much content was added */
    var secondsPerPass = parseFloat(track.dataset.tsMarqueeSpeed || track.style.animationDuration) || 32;
    track.style.animationDuration = (secondsPerPass * reps) + 's';
    if (!track.dataset.tsMarqueeSpeed) track.dataset.tsMarqueeSpeed = String(secondsPerPass);
  }

  var marqueeResizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(marqueeResizeTimer);
    marqueeResizeTimer = setTimeout(function () {
      document.querySelectorAll('.ts-marquee-track').forEach(fillMarquee);
    }, 150);
  });

  /* ---------- buy now + sticky bar (product page) ---------- */
  document.addEventListener('click', function (e) {
    var sticky = e.target.closest('[data-ts-sticky-add]');
    var buynow = e.target.closest('[data-ts-buynow]');
    if (!sticky && !buynow) return;
    var form = document.querySelector('[data-ts-product-form]');
    if (!form) return;
    e.preventDefault();
    if (sticky) { ajaxAdd(form); return; }
    /* Buy now: add the selected variant, then straight to checkout */
    var data = new FormData(form);
    fetch(routes.cart_add_url || '/cart/add', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: data
    }).then(function () { window.location.href = '/checkout'; })
      .catch(function () { window.location.href = '/checkout'; });
  });

  /* ---------- boot ---------- */
  function boot() {
    document.querySelectorAll('[data-ts-hero]').forEach(initHero);
    document.querySelectorAll('[data-ts-product]').forEach(initProduct);
    document.querySelectorAll('.ts-marquee-track').forEach(fillMarquee);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
